<script setup>
import { __ } from '@/utils';

const props = defineProps({
	hint: Object,
	help: Boolean
});
</script>
<template>
	<div class="tooltip" :class="{'tooltip--help': props.help}">
		<span class="tooltip__trigger"></span>

		<div class="tooltip__content" v-if="hint">
			<h6 v-if="hint?.title">
				{{ hint.title }}
			</h6>

			<p v-if="hint?.description">
				{{ hint.description }}
			</p>

			<slot />
		</div><!-- /.tooltip__content -->
	</div><!-- /.tooltip -->
</template>

